import { LOGIN_MODAL } from "../../../constants/ModalConstants";
import LoginModal from "./LoginModal";
import Modal from "../ui/Modal";
import React from "react";
import { useActiveModal } from "../../../state/hooks/ModalHooks/useActiveModal";

const Modals = () => {
    const { activeModal, setActiveModal } = useActiveModal();
    return (
        <Modal open={Boolean(activeModal)} onBackdrawClick={() => setActiveModal()}>
            {(() => {
                switch (activeModal) {
                    case LOGIN_MODAL:
                        return <LoginModal />;
                    default:
                        return null;
                }
            })()}
        </Modal>
    );
};

export default Modals;
